<mat-card style="background-color: darkgrey;width: 100%; height: 100%; box-sizing: border-box;">
    <img mat-card-image src="../../../assets/about_page.png">
</mat-card>